import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import AdminShell from "../components/admin/AdminShell";
import AdminKraPanel from "../components/views/admin/AdminKraPanel";
import { SkeletonAdminBody } from "../components/Skeleton";

function AdminKraPage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/login");

      try {
        const res = await api.get("/auth/me");
        const raw = res?.data;
        const userData = raw && raw.user ? raw.user : raw;

        if (!userData || !userData._id) {
          navigate("/login");
          return;
        }

        if (userData.role !== "A") {
          navigate("/dashboard");
          return;
        }

        if (userData.locked) {
          navigate("/locked");
          return;
        }

        setUser(userData);
      } catch (error) {
        console.error("Error fetching user:", error);
        localStorage.removeItem("token");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-50 font-sans">
        <SkeletonAdminBody rows={6} />
      </div>
    );
  }

  if (!user) return null;

  return (
    <AdminShell user={user} title="KRA PRN" subtitle="KRA Tools">
      <div className="mb-4 sm:mb-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-red-600">Admin Tools</p>
        <h2 className="mt-1 text-xl sm:text-2xl font-bold text-gray-900">KRA Rental Withholding</h2>
      </div>

      <AdminKraPanel />
    </AdminShell>
  );
}

export default AdminKraPage;
